module.exports = __webpack_public_path__ + "img/九州机构通客户操作手册11195.6416dd2d.png";